import { render, staticRenderFns } from "./PricePointsStep.vue?vue&type=template&id=4084aee6&scoped=true"
import script from "./PricePointsStep.vue?vue&type=script&lang=js"
export * from "./PricePointsStep.vue?vue&type=script&lang=js"
import style0 from "./PricePointsStep.vue?vue&type=style&index=0&id=4084aee6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4084aee6",
  null
  
)

export default component.exports